import { createSelector } from 'reselect';
import { currentBotSelector } from '.';

export const chatListSelector = createSelector(
  currentBotSelector,
  bot => bot.chatList || []
);
